/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { RevokeSessionResponse, RevokeSessionVars } from '../openapi-types.gen.js';

export type { RevokeSessionResponse, RevokeSessionVars } from '../openapi-types.gen.js';

export const useRevokeSession = createMutationHook<RevokeSessionVars, RevokeSessionResponse, unknown>({
  specName: 'useRevokeSession',
  path: '/v1/auth/sessions/{id}',
  method: 'DELETE',
  resolveUrl: (vars: RevokeSessionVars) => `/v1/auth/sessions/${vars.id}`,
  
  parseResponse: (raw: unknown): RevokeSessionResponse => raw as RevokeSessionResponse,
  optimistic: [{
    queryKey: ['accounts', 'viewer'],
    reconcile: false,
    entityGraph: true,
    apply: (prev: any, vars: RevokeSessionVars, queryKey: readonly unknown[], queryClient: any, viewerScope: string, networkScope: string) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyPrivateAccountSessionRevokeOptimistic as unknown as (prev: any, vars: RevokeSessionVars, queryKey: readonly unknown[], queryClient: any, viewerScope: string, networkScope: string) => any)(next, vars, queryKey, queryClient, viewerScope, networkScope);
      return next;
    },
  }],
  
  
});
